import { TextLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useSelector } from 'react-redux'

import { useExportAsTxt } from '@/hooks'
import { selectIsLoading } from '@/store'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportTxt: React.FC<Props> = ({ exportable }) => {
  const txtLoading = useSelector(selectIsLoading('export_txt'))

  const onClick = useExportAsTxt()

  return (
    <ExportItem
      label="TXT"
      exportable={exportable}
      loading={txtLoading}
      icon={TextLight}
      onClick={onClick}
    />
  )
}
